import dayjs from 'dayjs';

interface ReleaseDateBadgeProps {
  releaseDate: string | null | undefined;
  releaseYear: number | string | null | undefined;
  className?: string;
  title?: string;
  showTitle?: boolean;
}

export function ReleaseDateBadge({
  releaseDate,
  releaseYear,
  className = '',
  title,
  showTitle = false,
}: ReleaseDateBadgeProps) {
  const isFutureRelease = releaseDate && dayjs(releaseDate).isAfter(dayjs());
  const displayDate = formatReleaseDateForDisplay(releaseDate);
  const displayValue = isFutureRelease ? displayDate : releaseYear;
  const titleText = formatReleaseDateForDisplay(releaseDate);

  return (
    <span
      className={`${className}${isFutureRelease ? ' release-badge--future' : ''}`}
      title={titleText}
    >
      {showTitle && title ? `${title} ` : ''}
      {displayValue}
    </span>
  );
}

function formatReleaseDateForDisplay(
  releaseDate: string | null | undefined,
): string {
  if (!releaseDate) return '';
  try {
    return dayjs(releaseDate).format('DD.MM.YYYY');
  } catch {
    return '';
  }
}
